module.exports = __webpack_public_path__ + "assets/img/hcpimg31.b79b24b5.png";